import produce from 'immer';
import { IN_APP_ICONS_LIST_REQUEST } from '../../constants/app/inAppIconsConstants';

const initialState = {

}

const inAppIconsReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case IN_APP_ICONS_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default inAppIconsReducer;
